import axios from 'axios';

// Configuración base de axios - usar URL relativa /api para que Apache haga proxy
const API = axios.create({
  baseURL: '/api/gestor_software', // Usar siempre la ruta relativa para el proxy
  timeout: 30000
});

// Interceptor para añadir token automáticamente
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth services
export const authAPI = {
  register: (userData) => API.post('/auth/register', userData),
  login: (credentials) => API.post('/auth/login', credentials),
  getProfile: () => API.get('/auth/profile'),
  createAdmin: (adminData) => API.post('/auth/create-admin', adminData)
};

// Software services
export const softwareAPI = {
  getAll: (params) => API.get('/software', { params }),
  getById: (id) => API.get(`/software/${id}`),
  create: (formData) => API.post('/software', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, data) => API.put(`/software/${id}`, data),
  delete: (id) => API.delete(`/software/${id}`),
  getCategories: () => API.get('/software/categories')
};

// Download services
export const downloadAPI = {
  download: (id) => {
    // Para descargas usamos una URL directa
    const token = localStorage.getItem('token');
    const url = `${API.defaults.baseURL}/downloads/${id}`;
    
    if (token) {
      // Si hay token, añadirlo como parámetro
      window.open(`${url}?token=${token}`, '_blank');
    } else {
      window.open(url, '_blank');
    }
  },
  getStats: (params) => API.get('/downloads/stats', { params }),
  getHistory: (params) => API.get('/downloads/history', { params }),
  getDashboard: () => API.get('/downloads/dashboard')
};

export default API;